/* ==================== CARRITO ====================
   Cajon lateral en vez de la pagina /cart: quien agrega algo no pierde el punto
   del scroll donde iba, y la compra pierde un paso completo.

   Vive aparte porque lo usan el home y la pagina del club. Se pinta solo: la
   pagina nada mas necesita un boton con id="clnavCart" en su barra.

   Habla con la Cart AJAX API de Shopify. Fuera de Shopify (preview local) esos
   endpoints no existen y se cae a un carrito en memoria para revisar el diseno. */
(function(){
'use strict';

/* IDs reales de la tienda */
const VAR={
  '400'  :{original:42110569644101, cacao:42110569676869, vainilla:42110569709637,
           coco:null,               caramelo:42110569775173},
  '1l'   :42182029082693,
  shots  :42182021152837,
  molido :42193856987205
};
const INFO={
  '400'  :{n:'Cold Brew 400ml',   p:11000},
  '1l'   :{n:'Cold Brew 1 Litro', p:22000},
  shots  :{n:'Shot de Cold Brew', p:2900},
  molido :{n:'Café Molido 250g',  p:12500}
};
const NOMBRE={original:'Original',cacao:'Cacao',vainilla:'Vainilla',coco:'Coco',caramelo:'Caramelo'};
const ENVIO_GRATIS=40000;                       /* centavos: $400 */
const pesos=c=>'$'+(c/100).toLocaleString('es-MX',{maximumFractionDigits:0});

/* ---- el cajon se inyecta solo, para no repetirlo en cada pagina ----
   Va DENTRO de .cl-home cuando existe: en Shopify todo nuestro CSS esta
   encerrado bajo esa clase, y colgado del <body> el cajon sale sin una sola
   regla aplicada (aparece como bloque suelto debajo del footer). */
const RAIZ=document.querySelector('.cl-home')||document.body;
RAIZ.insertAdjacentHTML('beforeend',`
<div class="clc-velo" id="clcVelo" aria-hidden="true"></div>
<aside class="clcart" id="clcart" role="dialog" aria-modal="true" aria-label="Tu carrito" aria-hidden="true">
  <div class="clc-top">
    <h3>Tu carrito</h3>
    <button class="clc-x" id="clcX" aria-label="Cerrar carrito">&times;</button>
  </div>
  <div class="clc-body" id="clcBody"></div>
  <div class="clc-pie">
    <div class="clc-sum"><span>Subtotal</span><b id="clcSum">$0</b></div>
    <p class="clc-envio" id="clcEnvio">Envío gratis desde $400.</p>
    <a class="cl-btn clc-go" href="/checkout">Ir a pagar</a>
    <button class="clc-seguir" id="clcSeguir">Seguir comprando</button>
  </div>
</aside>`);

const $=s=>document.getElementById(s);
const cajon=$('clcart'), velo=$('clcVelo'), cuerpo=$('clcBody'),
      suma=$('clcSum'), envio=$('clcEnvio'), boton=$('clnavCart'), cuenta=$('clnavN');

let LOCAL=null;                                 /* solo se llena si no hay Shopify */

async function pide(url, body){
  try{
    const r=await fetch(url, body?{method:'POST',headers:{'Content-Type':'application/json'},
                                   body:JSON.stringify(body)}:undefined);
    if(!r.ok) throw 0;
    const j=await r.json();
    if(!j || (!('items' in j) && !('item_count' in j))) throw 0;
    return j;
  }catch(e){ if(LOCAL===null) LOCAL={items:[]}; return null; }
}

/* la foto de cada linea sale del DOM, asi no hay rutas nuevas que portar */
function foto(sku, sabor){
  const img=document.querySelector(sku==='400'
    ? `.fcard[data-flavor="${sabor}"] img, .pcard[data-sku="400"] img`
    : `.pcard[data-sku="${sku}"] img, .role[data-a="${sku}"] img`);
  return img?img.src:'';
}

const carrito=async()=> (await pide('/cart.js')) || LOCAL || {items:[]};

async function agrega(sku, sabor, plan){
  const id = sku==='400' ? VAR['400'][sabor] : VAR[sku];
  if(!id) return false;                         /* sabor que todavia no se vende */
  const linea={id, quantity:1}; if(plan) linea.selling_plan=plan;
  const j=await pide('/cart/add.js',{items:[linea]});
  if(!j){                                        /* preview local */
    const clave=String(id), hay=LOCAL.items.find(x=>x.key===clave);
    if(hay) hay.quantity++;
    else LOCAL.items.push({key:clave, quantity:1, price:INFO[sku].p,
      product_title:INFO[sku].n,
      variant_title: sku==='400' ? NOMBRE[sabor] : null,
      image:foto(sku,sabor)});
  }
  return true;
}

async function cambia(key, qty){
  const j=await pide('/cart/change.js',{id:key, quantity:qty});
  if(!j){
    const i=LOCAL.items.findIndex(x=>x.key===key);
    if(i>-1){ if(qty<=0) LOCAL.items.splice(i,1); else LOCAL.items[i].quantity=qty; }
  }
}

function pinta(c){
  const items=c.items||[];
  const total=items.reduce((s,x)=>s+x.price*x.quantity,0);
  const n=items.reduce((s,x)=>s+x.quantity,0);
  if(cuenta) cuenta.textContent=n;
  if(boton) boton.toggleAttribute('data-vacio', n===0);
  suma.textContent=pesos(total);
  const falta=ENVIO_GRATIS-total;
  envio.innerHTML = n===0 ? 'Envío gratis desde $400.'
    : falta>0 ? `Te faltan <b>${pesos(falta)}</b> para el envío gratis.`
              : '<b>Envío gratis</b> incluido.';
  cuerpo.innerHTML = n===0
    ? '<p class="clc-vacio">Todavía no hay nada aquí.<br>Empieza por los 400 ml.</p>'
    : items.map(x=>`<div class="clc-linea" data-key="${x.key}">
        <span class="clc-foto">${x.image?`<img src="${x.image}" alt="">`:''}</span>
        <span class="clc-info">
          <span class="clc-nom">${x.product_title}</span>
          ${x.variant_title&&x.variant_title!=='Default Title'?`<span class="clc-var">${x.variant_title}</span>`:''}
          ${x.selling_plan_allocation?`<span class="clc-plan">${x.selling_plan_allocation.selling_plan.name}</span>`:''}
          <span class="clc-fila">
            <span class="clc-qty">
              <button data-mas="-1" aria-label="Quitar uno">&minus;</button>
              <span>${x.quantity}</span>
              <button data-mas="1" aria-label="Agregar uno">+</button>
            </span>
            <span class="clc-precio">${pesos(x.price*x.quantity)}</span>
          </span>
        </span>
      </div>`).join('');
}

async function abre(abrir){
  cajon.classList.toggle('abierto',abrir); velo.classList.toggle('abierto',abrir);
  cajon.setAttribute('aria-hidden',String(!abrir));
  document.body.style.overflow=abrir?'hidden':'';   /* la clase no sirve: el CSS esta encerrado */
  const st=document.getElementById('sticky');
  if(abrir){ if(st) st.classList.remove('show'); pinta(await carrito()); }
}

if(boton) boton.addEventListener('click',()=>abre(true));
$('clcX').addEventListener('click',()=>abre(false));
$('clcSeguir').addEventListener('click',()=>abre(false));
velo.addEventListener('click',()=>abre(false));
addEventListener('keydown',e=>{if(e.key==='Escape')abre(false)});

cuerpo.addEventListener('click',async e=>{
  const b=e.target.closest('[data-mas]'); if(!b) return;
  const linea=b.closest('.clc-linea');
  const q=+linea.querySelector('.clc-qty span').textContent + (+b.dataset.mas);
  await cambia(linea.dataset.key, Math.max(0,q));
  pinta(await carrito());
});

/* ---- barra ----
   Vive aqui y no en cada pagina: todas las plantillas del tema montan la misma
   barra y solo cargan este archivo. */
const barra=document.getElementById('clnav'), hamb=document.getElementById('clnavBurger');
if(barra){
  addEventListener('scroll',()=>barra.classList.toggle('solido',scrollY>40),{passive:true});
  if(scrollY>40) barra.classList.add('solido');
  if(hamb) hamb.addEventListener('click',()=>{
    const on=!barra.classList.contains('abierto');
    barra.classList.toggle('abierto',on); hamb.setAttribute('aria-expanded',String(on));
  });
  const links=document.getElementById('clnavLinks');
  if(links) links.addEventListener('click',()=>{
    barra.classList.remove('abierto'); if(hamb) hamb.setAttribute('aria-expanded','false');
  });
}

carrito().then(pinta);
window.CLCart={agrega, abre, refresca:async()=>pinta(await carrito()),
  /* para la pagina de producto, donde el id de variante ya se conoce */
  agregaVariante:async(id, qty, plan)=>{
    const linea={id:+id, quantity:qty||1}; if(plan) linea.selling_plan=+plan;
    const j=await pide('/cart/add.js',{items:[linea]});
    if(!j){ const k=String(id), hay=LOCAL.items.find(x=>x.key===k);
      if(hay) hay.quantity+=(qty||1);
      else LOCAL.items.push({key:k, quantity:qty||1, price:0, product_title:'Producto', image:''}); }
    return true;
  }};
})();
